import { Box, Grid } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { UserNotFoundInEvfSystemError } from "../Constant";

export const UserNotFoundInEvf = (props) => {
  const { t, i18n } = useTranslation();

  return (
    <Box>
      <Grid container className="container padding bottom-2" direction="column" justifyContent="center" alignItems="center">
        <Grid item>
          <h1>{t(UserNotFoundInEvfSystemError)}</h1>
        </Grid>
        <Grid item>
          <a href="/login">{t("logout")}</a>
        </Grid>
      </Grid>
    </Box>
  );
};
